var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'empty-state-into-card': _vm.$route.name === 'campaigns',
    'has-trial-alert': _vm.hasTrialAlert}},[_c('Icon',{attrs:{"icon":_vm.icon}}),_c('p',[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }